import React, { ReactElement, useState } from "react";
import { Droppable } from "@hello-pangea/dnd";
import { Button, Form } from "react-bootstrap";

export interface KanbanLaneData {
	id: string;
	title: string;
	color: string;
}

interface KanbanLaneProps {
	lane: KanbanLaneData;
	children: React.ReactNode;
	onAddCard?: (laneId: string, title: string, description: string) => void;
}

export const KanbanLane = ({
	lane,
	children,
	onAddCard,
}: KanbanLaneProps): ReactElement => {
	const [isAdding, setIsAdding] = useState(false);
	const [newCardTitle, setNewCardTitle] = useState("");

	const handleSubmit = (e: React.FormEvent) => {
		e.preventDefault();
		if (newCardTitle.trim() && onAddCard) {
			onAddCard(lane.id, newCardTitle.trim(), "");
			setNewCardTitle("");
			setIsAdding(false);
		}
	};

	const handleCancel = () => {
		setNewCardTitle("");
		setIsAdding(false);
	};

	return (
		<div className="kanban-lane">
			<div
				className="kanban-lane-header"
				style={{ borderTopColor: lane.color }}
			>
				<span className="kanban-lane-title">{lane.title}</span>
			</div>

			<Droppable droppableId={lane.id}>
				{(provided, snapshot) => (
					<div
						ref={provided.innerRef}
						{...provided.droppableProps}
						className={`kanban-lane-content ${
							snapshot.isDraggingOver ? "dragging-over" : ""
						}`}
					>
						{children}
						{provided.placeholder}
					</div>
				)}
			</Droppable>

			{onAddCard && (
				<div className="kanban-lane-footer">
					{isAdding ? (
						<Form onSubmit={handleSubmit} className="kanban-add-card-form">
							<Form.Control
								type="text"
								placeholder="Enter task title..."
								value={newCardTitle}
								onChange={(e) => setNewCardTitle(e.target.value)}
								autoFocus
								size="sm"
							/>
							<div className="kanban-add-card-actions">
								<Button type="submit" size="sm" variant="primary">
									Add
								</Button>
								<Button
									type="button"
									size="sm"
									variant="link"
									onClick={handleCancel}
								>
									Cancel
								</Button>
							</div>
						</Form>
					) : (
						<Button
							variant="link"
							className="kanban-add-card-btn"
							onClick={() => setIsAdding(true)}
						>
							+ Add Card
						</Button>
					)}
				</div>
			)}
		</div>
	);
};
